module.exports = __webpack_public_path__ + "3bbf4760a743a484adb715b94e624c7c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/3/Assets/img1.jpeg
// module id = 1354
// module chunks = 0